import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import {
  ordersColumns,
  publisherColumns,
  userColumns,
} from "../../datatablesource";
import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  limit,
  getCountFromServer,
  startAfter,
  orderBy,
  where,
  collectionGroup,
} from "firebase/firestore";
import { db } from "../../firebase";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Close, SearchOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PAGE_SIZE = 10;
var lastVisible;
var searchQuery = null;
var orderByQuery = null;

const Datatable = ({ type }) => {
  let dataValue;
  switch (type) {
    case "users":
      dataValue = {
        columns: userColumns,
        collectionVal: collection(db, "Users"),
        redirectVal: "users",
        query: {
          nameQuery: {
            where: "searchKeywords",
            orderBy: "user_name",
          },
          emailQuery: {
            where: "user_email",
            orderBy: "user_email",
          },
          phoneQuery: {
            where: "mobile_number",
            orderBy: "mobile_number",
          },
        },
      };
      break;
    case "orders":
      dataValue = {
        columns: ordersColumns,
        collectionVal: collectionGroup(db, "Library"),
        redirectVal: "orders",
      };
      break;
    case "publishers":
      dataValue = {
        columns: publisherColumns,
        collectionVal: collection(db, "publishers"),
        redirectVal: "publishers",
        query: {
          nameQuery: {
            where: "searchKeywords",
            orderBy: "fullName",
          },
          emailQuery: {
            where: "emailAddress",
            orderBy: "emailAddress",
          },
          phoneQuery: {
            where: "phoneNumber",
            orderBy: "phoneNumber",
          },
        },
      };
      break;
    default:
      break;
  }
  const navigate = useNavigate();
  const handleClick = (id, userID) => {
    const eUrl = `/orders/${id}`;
    const newTab = window.open(eUrl, "_blank");

    // Optional: Pass additional data to the new tab if needed
    if (newTab) {
      newTab.myData = { userID };
    }
  };
  const [data, setData] = useState([]);
  const [radioValue, setRadioValue] = useState("name");
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [isThereSearchText, setIsThereSearchText] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [dataCache, setDataCache] = useState({});

  const handleChange = (event) => {
    setRadioValue(event.target.value);
  };

  const handleSearchClick = async () => {
    setData([]);
    setDataCache({});
    setPage(0);
    lastVisible = null;
    switch (radioValue) {
      case "name":
        searchQuery = where(
          `${dataValue.query.nameQuery.where}`,
          "array-contains",
          searchText
        );
        orderByQuery = orderBy(`${dataValue.query.nameQuery.orderBy}`);
        break;
      case "email":
        searchQuery = where(
          `${dataValue.query.emailQuery.where}`,
          "==",
          searchText
        );
        orderByQuery = orderBy(`${dataValue.query.emailQuery.orderBy}`);
        break;
      case "phone":
        searchQuery = where(
          `${dataValue.query.phoneQuery.where}`,
          "==",
          searchText
        );
        orderByQuery = orderBy(`${dataValue.query.phoneQuery.orderBy}`);
        break;
      default:
        break;
    }
    setLoading(true);

    let newData;
    var userQuery;

    if (searchQuery != null && orderByQuery != null && lastVisible != null) {
      userQuery = query(
        dataValue.collectionVal,
        searchQuery,
        orderByQuery,
        startAfter(lastVisible),
        limit(PAGE_SIZE)
      );
    } else if (
      searchQuery != null &&
      orderByQuery != null &&
      lastVisible === null
    ) {
      userQuery = query(
        dataValue.collectionVal,
        searchQuery,
        orderByQuery,
        limit(PAGE_SIZE)
      );
      const totalDocuments = await getCountFromServer(
        query(dataValue.collectionVal, searchQuery, orderByQuery)
      );
      const totalDataCount = totalDocuments.data().count;
      setTotalPages(Math.ceil(totalDataCount / PAGE_SIZE));
    } else if (lastVisible != null) {
      userQuery = query(
        dataValue.collectionVal,
        startAfter(lastVisible),
        limit(PAGE_SIZE)
      );
    } else {
      userQuery = query(dataValue.collectionVal, limit(PAGE_SIZE));
    }
    const querySnapshot = await getDocs(userQuery);
    lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

    newData = querySnapshot.docs.map((doc) => {
      const combinedId =
        type === "orders" ? `${doc.id}${doc.ref.parent.parent.id}` : doc.id;
      const userId = type === "orders" ? doc.ref.parent.parent.id : null;
      const orderId = type === "orders" ? doc.id : null;

      return {
        id: combinedId, // Use consistent naming for clarity
        userId, // Use clear property names
        orderId,
        ...doc.data(),
      };
    });

    setDataCache((prevCache) => ({ ...prevCache, [page]: newData }));

    setData(newData);
    setLoading(false);
  };

  const handleSearchClose = () => {
    searchQuery = null;
    setSearchText("");
    setIsThereSearchText(false);
  };

  const handleSearchText = (e) => {
    setSearchText(e.target.value);
    if (e.target.value.length != 0) {
      setIsThereSearchText(true);
    } else {
      searchQuery = null;
      setIsThereSearchText(false);
    }
  };

  useEffect(async () => {
    const totalDocuments = await getCountFromServer(dataValue.collectionVal);
    const totalDataCount = totalDocuments.data().count;
    setTotalPages(Math.ceil(totalDataCount / PAGE_SIZE));
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      let newData;

      if (dataCache[page]) {
        newData = dataCache[page];
      } else {
        var userQuery;

        if (
          searchQuery != null &&
          orderByQuery != null &&
          lastVisible != null
        ) {
          userQuery = query(
            dataValue.collectionVal,
            searchQuery,
            orderByQuery,
            startAfter(lastVisible),
            limit(PAGE_SIZE)
          );
        } else if (
          searchQuery != null &&
          orderByQuery != null &&
          lastVisible === null
        ) {
          userQuery = query(
            dataValue.collectionVal,
            searchQuery,
            orderByQuery,
            limit(PAGE_SIZE)
          );
          const totalDocuments = await getCountFromServer(
            query(dataValue.collectionVal, searchQuery, orderByQuery)
          );
          const totalDataCount = totalDocuments.data().count;
          setTotalPages(Math.ceil(totalDataCount / PAGE_SIZE));
        } else if (lastVisible != null) {
          userQuery = query(
            dataValue.collectionVal,
            startAfter(lastVisible),
            limit(PAGE_SIZE)
          );
        } else {
          userQuery = query(dataValue.collectionVal, limit(PAGE_SIZE));
        }
        /*query(
          dbRef,
          searchQuery ? searchQuery : null,
         orderByQuery ? orderByQuery : null,
         lastVisible ? startAfter(lastVisible) : null,
          limit(PAGE_SIZE)
        )*/

        const querySnapshot = await getDocs(userQuery);
        lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

        newData = querySnapshot.docs.map((doc) => {
          const combinedId =
            type === "orders" ? `${doc.id}${doc.ref.parent.parent.id}` : doc.id;
          const userId = type === "orders" ? doc.ref.parent.parent.id : null;
          const orderId = type === "orders" ? doc.id : null;
          return {
            id: combinedId, // Use consistent naming for clarity
            userId, // Use clear property names
            orderId,
            ...doc.data(),
          };
        });

        setDataCache((prevCache) => ({ ...prevCache, [page]: newData }));
      }

      setData(newData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {type !== "orders" && (
              <Button
                variant="outlined"
                href={"/" + dataValue.redirectVal + "/" + params.id}
                target="_blank"
              >
                View
              </Button>
            )}
            {type === "orders" && (
              <Button
                variant="outlined"
                onClick={() =>
                  handleClick(params.row.orderId, params.row.userId)
                }
              >
                View
              </Button>
            )}
          </div>
        );
      },
      sortable: false,
    },
  ];

  return (
    <div className="datatable">
      <div className="datatableTitle">
        {type !== "orders" && (
          <div className="searchSection">
            <div className="search">
              <input
                type="text"
                value={searchText}
                placeholder="Search..."
                onChange={handleSearchText}
              />
              {isThereSearchText && <Close onClick={handleSearchClose} />}
              <SearchOutlined />
            </div>

            <FormControl sx={{ marginRight: "30px" }}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={radioValue}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="name"
                  control={<Radio size="small" />}
                  label="Name"
                />
                <FormControlLabel
                  value="email"
                  control={<Radio size="small" />}
                  label="Email"
                />
                <FormControlLabel
                  value="phone"
                  control={<Radio size="small" />}
                  label="Phone"
                />
              </RadioGroup>
            </FormControl>
            <Button variant="outlined" onClick={handleSearchClick}>
              Search
            </Button>
          </div>
        )}
      </div>
      <DataGrid
        disableColumnFilter
        disableColumnMenu
        className="datagrid"
        rows={data}
        columns={dataValue.columns.concat(actionColumn)}
        pagination
        pageSize={PAGE_SIZE}
        rowCount={totalPages * PAGE_SIZE}
        paginationMode="server"
        loading={loading}
        onPageChange={(newPage) => setPage(newPage)}
      />
    </div>
  );
};

export default Datatable;
